import $ from "jquery";
import { Swiper } from "swiper";
import "swiper/scss";
import gsap from "gsap";

const $cursor = $(".js-cursor");
const $cursor_target = $(".js-cursor-on-slide");

const moveCursor = (e) => {
  gsap.to($cursor, {
    left: e.clientX,
    top: e.clientY,
  });
};

$(".js-slider").each(function () {
  const slideCount = $(this).find(".swiper-slide").length;
  const loopSlides = slideCount >= 5;

  const swiper = new Swiper(this.querySelector(".swiper"), {
    slidesPerView: "auto",
    loop: loopSlides,
    spaceBetween: 20,
    breakpoints: {
      768: {
        spaceBetween: 42,
      },
    },
    on: {
      touchMove: (swiper, e) => moveCursor(e),
    },
  });
});

$cursor_target.on({
  mouseenter: () => $cursor.show(),
  mouseleave: () => $cursor.hide(),
  mousemove: moveCursor,
});
